<div [ngStyle]="{padding: paddingPx}"><ion-select #mySelect (ionChange)="editInput()" [multiple]="multiple" [label]="label" mode="md"
    [disabled]="disabled" labelPlacement="floating" [interface]="interface" [placeholder]="label" [(ngModel)]="variable"
    fill="outline">
    <ion-select-option [value]="object[value]" *ngFor="let object of objectList">
      <div *ngIf="type!='String' && display2==null" style='padding-left: 40px; margin-left: 30px;'>{{object[display]}}
      </div>
      <div *ngIf="type!='String' && display2!=null" style='padding-left: 40px; margin-left: 30px;'>
        {{object[display][display2]}}</div>
      <div *ngIf="type=='String'" style='padding-left: 40px; margin-left: 30px;'>{{object}}</div>
    </ion-select-option>
  </ion-select>
  <div class='validationError' *ngIf="validationMessage">{{validationMessage}}</div>
</div>